import React, { useState } from "react";
import PropTypes from "prop-types";

import SlideOver from "../../tailwindUI/SlideOver";
import LongAlert from "../../tailwindUI/LongAlert";
import LinkButton from "../../tailwindUI/LinkButton";
import Table from "../../tailwindUI/Table";
import Pagination from "../../tailwindUI/Pagination";
import SearchBar from "../../tailwindUI/SearchBar";
import { useNotifications } from "../../hooks/collectionManager/useNotifications";
import EmptyState from "../../tailwindUI/EmptyState";

const tableSummaryColumns = [
  { heading: "Fecha", value: "date" },
  { heading: "Pendiente", value: "pending", align: "center" },
  { heading: "Enviado", value: "sent", align: "center" },
  { heading: "Fallido", value: "fail", align: "center" },
  { heading: "Cancelado", value: "canceled", align: "center" },
];

const tableUsersColumns = [
  { heading: "Email", value: "email" },
  { heading: "Teléfono", value: "phone_number" },
  { heading: "Canal", value: "channel" },
  { heading: "", value: "content", accordion: true },
];

export function NotificationSlide({ campaignId, disabled, refresh }) {
  const [openSlideForm, setOpenSlideForm] = useState(false);

  const {
    summaryData,
    usersData,
    pagination,
    currentPage,
    setCurrentPage,
    search,
    setSearch,
    isLoading,
    error,
    setError,
    scrollRef,
  } = useNotifications({ campaignId, refresh });

  const onClose = () => {
    setError(false);
    setOpenSlideForm(false);
  };

  return (
    <>
      {disabled ? (
        <p className="mt-1 text-sm font-normal text-gray-500">No disponible</p>
      ) : (
        <LinkButton
          onClick={() => setOpenSlideForm(true)}
          disabled={!openSlideForm && isLoading}
        >
          {!openSlideForm && isLoading ? "Cargando.." : "Ver detalles"}
        </LinkButton>
      )}
      <SlideOver
        ref={scrollRef}
        open={openSlideForm}
        setOpen={setOpenSlideForm}
        onClose={onClose}
        title="Detalles"
        className="w-full sm:max-w-[55dvw]"
      >
        {error && (
          <div className="w-full sticky mb-24 z-[30]">
            <LongAlert
              className="px-0"
              title={error}
              show={error !== null}
              onClose={() => setError(null)}
            />
          </div>
        )}

        <div className="space-y-6 pb-6">
          <div className="space-y-2">
            <h3 className="font-medium text-base text-gray-900">
              Resumen de notificaciones
            </h3>
            <Table
              title="Resumen de notificaciones"
              data={summaryData}
              isLoadingData={isLoading}
              columns={tableSummaryColumns}
            />
          </div>

          <div className="space-y-2">
            <h3 className="font-medium text-base text-gray-900">
              Detalle de usuarios
            </h3>
            <SearchBar
              value={search}
              setValue={setSearch}
              placeholder_desktop="Buscar usuario por email"
            />
          </div>
          {usersData ? (
            <div className="-mt-1">
              <Table
                title="Detalle de usuarios"
                data={usersData}
                isLoadingData={isLoading}
                columns={tableUsersColumns}
              />
            </div>
          ) : (
            <div className="w-full">
              <EmptyState
                title="No se encontraron usuarios"
                text="Verifica la información antes de continuar."
              />
            </div>
          )}

          {!isLoading && (
            <Pagination
              pages={pagination?.totalPages}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          )}
        </div>
      </SlideOver>
    </>
  );
}

NotificationSlide.propTypes = {
  campaignId: PropTypes.string,
  disabled: PropTypes.bool,
  refresh: PropTypes.bool,
};
